import { Box, SxProps } from '@mui/material';

export function DreFormRow({ children, sx }: { children: React.ReactNode; sx?: SxProps }) {
    return (
        <Box
            sx={{
                flex: 1,
                gap: 1.5,
                display: 'flex',
                alignItems: { md: 'center' },
                flexDirection: { xs: 'column', md: 'row' },
                ...sx,
            }}
        >
            {children}
        </Box>
    );
}
